import { Analytics } from 'cliengo-fe-utils';

function trackEvent(name: string, category: string, label = '') {
  Analytics.trackEvent({
    eventName: name,
    action: name,
    category,
    label,
  });
}

export function tryChatbot(category: string) {
  trackEvent('try_bot', category, 'genia_navbar');
}

export function continueOnboarding() {
  Analytics.trackEvent({
    eventName: 'Return_Onboarding',
    action: 'Return_Onboarding',
    category: 'Onboarding',
    label: 'Continuar_Onboarding',
  });
}

export function closeOnboarding() {
  Analytics.trackEvent({
    eventName: 'Close_Banner',
    action: 'Close_Banner',
    category: 'Onboarding',
    label: 'Cerrar_banneronboarding',
  });
}

export function goToReports() {
  Analytics.trackEvent({
    eventName: 'GoTo_Reports',
    action: 'GoTo_Reports',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}
export function goToAffiliates() {
  Analytics.trackEvent({
    eventName: 'GoTo_Affiliates',
    action: 'GoTo_Affiliates',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToHome() {
  Analytics.trackEvent({
    eventName: 'GoTo_Home',
    action: 'GoTo_Home',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToDashboard() {
  Analytics.trackEvent({
    eventName: 'GoTo_Dashboard',
    action: 'GoTo_Dashboard',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToChatbots() {
  Analytics.trackEvent({
    eventName: 'GoTo_Chatbots',
    action: 'GoTo_Chatbots',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToContacs() {
  Analytics.trackEvent({
    eventName: 'GoTo_Contacts',
    action: 'GoTo_Contacts',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToInbox() {
  Analytics.trackEvent({
    eventName: 'GoTo_Inbox',
    action: 'GoTo_Inbox',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToHistorial() {
  Analytics.trackEvent({
    eventName: 'GoTo_Historial',
    action: 'GoTo_Historial',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToTeam() {
  Analytics.trackEvent({
    eventName: 'GoTo_Team',
    action: 'GoTo_Team',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToCompaigns() {
  Analytics.trackEvent({
    eventName: 'GoTo_Campaigns',
    action: 'GoTo_Campaigns',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToHelpWeb() {
  Analytics.trackEvent({
    eventName: 'GoTo_Help_web',
    action: 'GoTo_Help',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToHelpWa() {
  Analytics.trackEvent({
    eventName: 'GoTo_Help_wa',
    action: 'GoTo_Help',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function clickProfile() {
  Analytics.trackEvent({
    eventName: 'Click_Profile',
    action: 'GoTo_Profile',
    category: 'CliengoHub',
    label: 'TopBar',
  });
}

export function goToProfile() {
  Analytics.trackEvent({
    eventName: 'GoTo_Profile',
    action: 'GoTo_Profile',
    category: 'CliengoHub',
    label: 'Sidebar',
  });
}

export function goToCompany() {
  Analytics.trackEvent({
    eventName: 'GoTo_Company',
    action: 'GoTo_Company',
    category: 'CliengoHub',
    label: 'Topbar',
  });
}

export function goToPlans() {
  Analytics.trackEvent({
    eventName: 'GoTo_Plans',
    action: 'GoTo_Plans',
    category: 'CliengoHub',
    label: 'Topbar',
  });
}

export function goToBilling() {
  Analytics.trackEvent({
    eventName: 'GoTo_Billing',
    action: 'GoTo_Billing',
    category: 'CliengoHub',
    label: 'Topbar',
  });
}

export function goToGads() {
  Analytics.trackEvent({
    eventName: 'Enter_googleads',
    action: 'Enter_googleads',
    category: 'CliengoHub',
    label: 'Campañas',
  });
}

export function goToHsm() {
  Analytics.trackEvent({
    eventName: 'Enter_Hsm',
    action: 'Enter_Hsm',
    category: 'CliengoHub',
    label: 'Campañas',
  });
}

export function goToChatbotMetrics() {
  Analytics.trackEvent({
    eventName: 'Enter_Chatbot_Metrics',
    action: 'Enter_Chatbot_Metrics',
    category: 'CliengoHub',
    label: 'Reportes',
  });
}

export function goToAiReports() {
  Analytics.trackEvent({
    eventName: 'Enter_IA_Metrics',
    action: 'Enter_IA_Metrics',
    category: 'CliengoHub',
    label: 'Reportes',
  });
}
